export enum DbDocConnector {
    SourceCode = "dbdoc",
    DbDocFolderOwnerName = "Reporting v3",
    DefaultNamedQueries = "view"
}
